import React from 'react';
import { params, string, number, useDataModel } from '@thd-nucleus/data-sources';

export const QuestionsAnswersLoader = ({ itemId, children }) => {
  const { data, loading, error } = useDataModel('questionsAnswers',
    {
      variables: {
        itemId,
        pagesize: 4,
        searchTerm: '',
        sortBy: 'newest',
        startindex: 1
      }
    });

  return children({
    data,
    loading,
    error
  });
};

QuestionsAnswersLoader.dataModel = {
  questionsAnswers: params({
    itemId: string().isRequired(),
    pagesize: number(),
    sortBy: string(),
    startindex: number(),
    searchTerm: string()
  }).shape({
    TotalResults: number()
  })
};
